import {Image} from "../../models/images";
import {Box, Modal, Typography} from "@mui/material";
import "./ImagesModal.scss";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import React from "react";
import {useNavigate} from "react-router";

interface ImagesModalInterface {
    image: Image;
    open: boolean;
    handleClose: () => void;
}

export const ImagesModal = ({image, open, handleClose}: ImagesModalInterface) => {

    const navigate = useNavigate();

    return (
        <Modal open={open} onClose={handleClose}>
            <Box className="imageModal">
                <Box className="imageModal-image">
                    <img src={image.base64Image} alt={image.name}/>
                </Box>
                <Box className="imageModal-stats">
                    <h1>{image.name}</h1>
                    <p>{image.description}</p>

                    <Box className="images-item-actions">
                        <PlayArrowIcon className="images-item-actions-run"
                                       onClick={() => navigate("/batch?create=" + image.id)}/>
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};
